import SettingPage from "../common/SettingPage";
import Header from "../Settings/Header";
import { __ } from "@wordpress/i18n";
import { useState } from "react";
import "../style/support.css";
import "../style/settings.css";
import { ReactComponent as Search } from "../assets/search.svg";
import { ReactComponent as RightAngle } from "../assets/rightAngle.svg";
import { ReactComponent as DownAngle } from "../assets/downAngle.svg";
import { ReactComponent as Rocket } from "../assets/rocket-icon.svg";
import { ReactComponent as Book } from "../assets/book-icon.svg";
import { ReactComponent as Plus } from "../assets/save-plus-icon.svg";
import { ReactComponent as Forum } from "../assets/forum.svg";
import { ReactComponent as Copy } from "../assets/copy.svg";
import { ReactComponent as ExportIcon } from "../assets/export.svg";
import supportMembers from "../assets/support-members.png";

import {
  copyToClipboard,
  exportStringToFile,
  loadAsset,
} from "../Helpers/Utils";
import HTMLReactParser from "html-react-parser";
import StickyWidget from "../StickyWidget";
import { useDispatch } from "react-redux";

const DocSearchBar = () => {
  const [searchTerm, setSearchTerm] = useState("");

  const openSearchDoc = () => {
    window.open(
      `https://smashballoon.com/search/?search=${searchTerm}&plugin=youtube`
    );
  };

  return (
    <div className="sby-search-doc">
      <div href="links.doc" target="_blank" className="sby-search-doc-field">
        <span
          className="sb-btn-icon"
          onClick={() => {
            openSearchDoc();
          }}
        >
          <Search />
        </span>
        <input
          className="sb-btn-input"
          id="sby-search-doc-input"
          placeholder={__("Search Documentation", "feeds-for-youtube")}
          onKeyUp={(evt) => {
            setSearchTerm(evt.target.value);
            if (evt.code === "Enter") {
              openSearchDoc();
            }
          }}
        />
      </div>
    </div>
  );
};

const SupportBlock = ({
  icon,
  title,
  description,
  links,
  buttonTitle,
  buttonLink,
}) => {
  return (
    <div className="sby-support-block">
      <div className="sb-block-header">{icon}</div>
      <h3>{title}</h3>
      <p>{description}</p>
      <div className="sb-articles-list">
        <ul>
          {links.map((link) => {
            return (
              <li>
                <a href={link.link}>
                  {link.title}
                  <span className="sb-list-icon">
                    <RightAngle />
                  </span>
                </a>
              </li>
            );
          })}
        </ul>
      </div>
      <div className="sby-sb-button">
        <a href={buttonLink} target="_blank">
          {buttonTitle}
          <span className="sb-btn-icon">
            <RightAngle />
          </span>
        </a>
      </div>
    </div>
  );
};

const ContactSection = () => {
  return (
    <div className="sby-support-contact-block clearfix">
      <div className="sb-contact-block-left">
        <div className="sb-cb-icon">
          <span>
            <Forum />
          </span>
        </div>
        <div className="sb-cb-content">
          <h3>
            {__("Need more support? We’re here to help.", "feeds-for-youtube")}
          </h3>
          <a
            href="https://smashballoon.com/youtube-feed/support/?license_type=free&version=2.0&utm_campaign=youtube-free&utm_source=support&utm_medium=submit-ticket"
            target="_blank"
            className="sb-cb-btn"
          >
            {__("Submit a Support Ticket", "feeds-for-youtube")}
            <span>
              <RightAngle />
            </span>
          </a>
        </div>
      </div>
      <div className="sb-contact-block-right">
        <div>
          <img src={loadAsset(supportMembers)} />
        </div>
        <p>
          {__(
            "Our fast and friendly support team is always happy to help!",
            "feeds-for-youtube"
          )}
        </p>
      </div>
    </div>
  );
};

const SystemInfo = () => {
  const [expanded, setExpanded] = useState(false);
  const [selectedFeed, setSelectedFeed] = useState(null);
  const [feedList] = useState(window.sby_settings.feeds);
  const dispatch = useDispatch();

  const onExport = () => {
    if (selectedFeed !== "-1" && selectedFeed !== null) {
      exportStringToFile(
        feedList[selectedFeed].settings,
        `sby-feed-${feedList[selectedFeed].id}.json`
      );
    }
  };
  return (
    <div className="sby-system-info-section">
      <div className="sby-system-header">
        <h3>{__("System Info", "feeds-for-youtube")}</h3>
        <button
          className="sby-copy-btn"
          onClick={() => {
            copyToClipboard(window.sby_settings.system_info_n).then(() => {
              dispatch({
                type: "add_notification",
                payload: {
                  type: "success",
                  content: __("Copied to Clipboard", "feeds-for-youtube"),
                },
              });
            });
          }}
        >
          <span>
            <Copy />
          </span>
          <span>{__("Copy", "feeds-for-youtube")}</span>
        </button>
      </div>
      <div className="sby-system-info">
        <div
          id="system_info"
          className={`system_info ${expanded ? "expanded" : "collapsed"}`}
        >
          {HTMLReactParser(window.sby_settings.system_info)}
        </div>
        <button
          className="sby-expand-btn"
          onClick={() => {
            setExpanded(!expanded);
          }}
        >
          <span>
            <DownAngle />
          </span>
          <span>
            {!expanded
              ? __("Expand", "feeds-for-youtube")
              : __("Collapse", "feeds-for-youtube")}
          </span>
        </button>
      </div>
      <div className="sby-export-settings-section">
        <div className="sby-export-left">
          <h3>{__("Export Settings", "feeds-for-youtube")}</h3>
          <p>
            {__(
              "Share your plugin settings easily with Support",
              "feeds-for-youtube"
            )}
          </p>
        </div>
        <div className="sby-export-right">
          <select
            onChange={(evt) => {
              setSelectedFeed(evt.target.value);
            }}
            id="sby-feeds-list"
            className="sby-select"
          >
            <option value="-1">{__("Select Feed", "feeds-for-youtube")}</option>
            {feedList.map((feed, index) => {
              return <option value={index}>{feed.feed_name}</option>;
            })}
          </select>
          <button
            disabled={selectedFeed === "-1" || selectedFeed === null}
            type="button"
            className="sby-btn sb-btn-grey"
            onClick={onExport}
          >
            <span className="icon">
              <ExportIcon />
            </span>
            {__("Export", "feeds-for-youtube")}
          </button>
        </div>
      </div>
    </div>
  );
};

const Support = () => {
  const sby_utm_campaign = window.sby_settings.sbyIsPro
    ? "youtube-pro"
    : "youtube-free";

  const StartedArticles = [
    {
      title: "Creating Your First YouTube Feed",
      link:
        "https://smashballoon.com/doc/setting-up-the-feeds-for-youtube-pro-wordpress-plugin/?youtube&utm_campaign=" +
        sby_utm_campaign +
        "&utm_source=support&utm_medium=docs&utm_content=Creating%20your%20first%20YouTube%20feed",
    },
    {
      title: "How do I Find a Channel ID?",
      link:
        "https://smashballoon.com/doc/find-youtube-channel-id/?youtube&utm_campaign=" +
        sby_utm_campaign +
        "&utm_source=support&utm_medium=docs&utm_content=How",
    },
    {
      title: "Guide to Creating and Using an API Key",
      link:
        "https://smashballoon.com/doc/youtube-api-key/?youtube&utm_campaign=" +
        sby_utm_campaign +
        "&utm_source=support&utm_medium=docs&utm_content=API%20Key",
    },
  ];
  const DocsArticles = [
    {
      title: "How do I Embed a Feed Into a Template Directly?",
      link:
        "https://smashballoon.com/doc/embed-youtube-gallery-in-a-page-template/?youtube&utm_campaign=" +
        sby_utm_campaign +
        "&utm_source=support&utm_medium=docs&utm_content=Embed",
    },
    {
      title: "My Feed is Showing Unlisted Videos",
      link:
        "https://smashballoon.com/doc/feed-is-showing-unlisted-private-videos/?youtube&utm_campaign=" +
        sby_utm_campaign +
        "&utm_source=support&utm_medium=docs&utm_content=Private%20Videos",
    },
    {
      title: "Can I Change When the Video Plays?",
      link:
        "https://smashballoon.com/doc/change-when-youtube-video-plays/?youtube&utm_campaign=" +
        sby_utm_campaign +
        "&utm_source=support&utm_medium=docs&utm_content=Change",
    },
  ];
  const AdditionalArticles = [
    {
      title: "How Does the Plugin Optimize Page Load Time?",
      link:
        "https://smashballoon.com/doc/what-does-feeds-for-youtube-do-to-prevent-my-site-from-loading-slowly/?youtube&utm_campaign=" +
        sby_utm_campaign +
        "&utm_source=support&utm_medium=docs&utm_content=Page%20Optimization",
    },
    {
      title: "Troubleshooting 'YouTube Data API has not been used in project'",
      link:
        "https://smashballoon.com/doc/error-youtube-data-api-has-not-been-used-in-project/?youtube&utm_campaign=" +
        sby_utm_campaign +
        "&utm_source=support&utm_medium=docs&utm_content=Private%20Videos",
    },
    {
      title: "Will Feeds For YouTube Work with Caching Plugins?",
      link:
        "https://smashballoon.com/doc/will-feeds-for-youtube-work-with-caching-plugins/?youtube&utm_campaign=" +
        sby_utm_campaign +
        "&utm_source=support&utm_medium=docs&utm_content=Caching",
    },
  ];
  return (
    <div id="sby-support" className="sby-support">
      <Header title={__("Support", "feeds-for-youtube")} />
      <SettingPage
        subContainer={true}
        title={__("Support", "feeds-for-youtube")}
        headerChildren={<DocSearchBar />}
        headerClassName="sby-section-header sby-settings-header pt-2"
      >
        <div className="sby-support-blocks clearfix">
          <SupportBlock
            icon={<Rocket />}
            links={StartedArticles}
            title={__("Getting Started", "feeds-for-youtube")}
            description={__(
              "Some helpful resources to get you started",
              "feeds-for-youtube"
            )}
            buttonTitle={__("More help getting started", "feeds-for-youtube")}
            buttonLink={
              "https://smashballoon.com/docs/getting-started/?youtube&utm_campaign=youtube-free&utm_source=support&utm_medium=docs"
            }
          />
          <SupportBlock
            icon={<Book />}
            links={DocsArticles}
            title={__("Docs & Troubleshooting", "feeds-for-youtube")}
            description={__(
              "Run into an issue? Check out our help docs.",
              "feeds-for-youtube"
            )}
            buttonTitle={__("View Documentation", "feeds-for-youtube")}
            buttonLink={
              "https://smashballoon.com/docs/documentation/?youtube&utm_campaign=youtube-free&utm_source=support&utm_medium=docs"
            }
          />
          <SupportBlock
            icon={<Plus />}
            links={AdditionalArticles}
            title={__("Additional Resources", "feeds-for-youtube")}
            description={__(
              "To help you get the most out of the plugin",
              "feeds-for-youtube"
            )}
            buttonTitle={__("View Blog", "feeds-for-youtube")}
            buttonLink={
              "https://smashballoon.com/docs/faqs/?youtube&utm_campaign=youtube-free&utm_source=support&utm_medium=docs"
            }
          />
        </div>
        <ContactSection />
        <SystemInfo />
        <StickyWidget />
      </SettingPage>
    </div>
  );
};

export default Support;
